<template>
    <nuxt-link :to="slug" class="flex flex-col mb-10 mt-12 lg:my-16 xl:my-24 overflow-hidden rounded-lg group">
        <div v-if="$device.isDesktop" class="group-hover:scale-[1.03] transition transition--slow">
            <app-image :src="desktopImage" :alt="title" preset="banner" />
        </div>
        <div v-else>
            <app-image :src="mobileImage" :alt="title" preset="banner" />
        </div>
    </nuxt-link>
</template>
<script>
export default {
    name: 'BannerZone',
    props: {
        title: {
            type: String,
            required: true,
        },
        slug: {
            type: String,
            required: true,
        },
        desktopImage: {
            type: String,
            required: true,
        },
        mobileImage: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.transition--slow {
    transition-duration: 0.5s;
}
</style>
